"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.3,12.14a5.7,5.7,0,1,0,5.7,5.7A5.7,5.7,0,0,0,18.3,12.14Zm2.46,4.18L18,20.13a.66.66,0,0,1-1,.08L15.9,19.06a.65.65,0,0,1,0-.92.6.6,0,0,1,.5-.18h0a.62.62,0,0,1,.41.19l.58.59,2.3-3.18a.62.62,0,0,1,.42-.27.7.7,0,0,1,.49.12.65.65,0,0,1,.26.42A.62.62,0,0,1,20.76,16.32Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.08,12.82V10.15L10.59,7.82,7.11,10.15v3.71l3.48,2.33L12.4,15A6.64,6.64,0,0,1,14.08,12.82Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.3,20.8V19.67l.88.53a6.39,6.39,0,0,1-.42-1.92L11.3,18v-.58l.48-.32A6.51,6.51,0,0,1,12.4,15l-1.81,1.2L7.11,13.86V10.15l3.48-2.33,3.49,2.33v2.67a6.56,6.56,0,0,1,1.42-.9V10.23L16,10l2,1.2L18.72,10l-1.27-.76,1-.54,2,1.21.73-1.22-1.28-.76,1-.52-.67-1.25-1,.51.08-1.47-1.41-.08L17.79,7.4l-1,.53.09-1.46-1.42-.09-.13,2.33L14.86,9,11.3,6.59V6l2-1.22-.74-1.21-1.26.77V3.2L13.3,2,12.56.78l-1.26.76V.46H9.88v1.1L8.61.79,7.88,2l2,1.21V4.35L8.61,3.59,7.88,4.8,9.88,6v.58L6.33,9l-.47-.25L5.72,6.38l-1.41.09.08,1.46-1-.53L3.26,5.07l-1.42.08.09,1.47L1,6.11.3,7.36l1,.52L0,8.64.73,9.86l2-1.21,1,.54L2.46,10l.73,1.22,2-1.2.49.26v3.56l-.49.26-2-1.2-.73,1.21,1.28.77-1,.53-2-1.2L0,15.37l1.27.77-1,.52L1,17.91l1-.51-.09,1.46L3.26,19l.14-2.34,1-.53-.08,1.47,1.41.08.14-2.33.47-.25,3.55,2.37V18l-2,1.21.73,1.22,1.27-.77v1.13L7.88,22l.73,1.22,1.27-.77v1.1H11.3V22.46l1.26.76.71-1.17-.09-.11Z",
    style: {
      fill: '#004864'
    }
  }));
};

exports["default"] = _default;